/**
 * Determinate whether dom1 and dom2 is the same dom or not.
 *
 * @param  {HTMLDivElement}  dom1
 * @param  {HTMLDivElement}  dom2
 * @return {Boolean}
 */
"use strict";

exports.__esModule = true;
exports["default"] = isDOMEquals;

function isDOMEquals(dom1, dom2) {
  return dom1 === dom2;
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/sweetalert-react/lib/utils/isDOMEquals.js
 ** module id = 179
 ** module chunks = 0
 **/